
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn",
      function () {
        return require("private-next-pages/learn/index.tsx");
      }
    ]);
  